import React, {useContext} from "react";
import {MessageBottomContainerContext} from "../../../Message.tsx";
import {useAppStore} from "../../../../../../GlobalStore/GlobalStore.ts";
import aiAvatarLight from '../../../../../../assets/aiAvatarLight.svg';
import aiAvatarDark from '../../../../../../assets/aiAvatarDark.svg';

interface AiAvatarProps {}

const AiAvatar: React.FC<AiAvatarProps> = ({ }) => {
    const settingsObj = useAppStore((state: any) => state.settingsObj);
    const { theme } = settingsObj;
    const { group } = useContext(MessageBottomContainerContext);

    // Extract and filter consecutive duplicate answeredBy values
    const getAnsweredByArray = (): string[] => {
        const answeredByValues = group.messages
            .map((msg: any) => msg.message.answeredBy)
            .filter((value: string) => value !== undefined && value !== null && value !== "Automatic");

        // Filter out consecutive duplicates
        return answeredByValues.filter((value: string, index: number) => {
            return index === 0 || value !== answeredByValues[index - 1];
        });
    };

    const answeredByArray = getAnsweredByArray();

    const aiIcon = theme === "dark" ? aiAvatarLight : aiAvatarDark;
    const anthropicLogo = "https://wfclardozsxtrutoorim.supabase.co/storage/v1/object/public/images/anthropicLogo.png";
    const openAiLogo = "https://wfclardozsxtrutoorim.supabase.co/storage/v1/object/public/images/openAiLogo.svg";
    const googleLogo = "https://wfclardozsxtrutoorim.supabase.co/storage/v1/object/public/images/geminiLogo.png";
    const xAiLogo = "https://wfclardozsxtrutoorim.supabase.co/storage/v1/object/public/images//grokLogo.svg";

    const getModelIcon = (answeredBy: string) => {
        if (answeredBy === "GPT") return openAiLogo;
        else if (answeredBy === "GPT-Mini") return openAiLogo;

        else if (answeredBy === "Claude-Fable") return anthropicLogo;
        else if (answeredBy === "Claude-Opus") return anthropicLogo;
        else if (answeredBy === "Claude-Sonnet") return anthropicLogo;
        else if (answeredBy === "Claude-Haiku") return anthropicLogo;

        else if (answeredBy === "Gemini-Pro") return googleLogo;
        else if (answeredBy === "Gemini-Flash") return googleLogo;

        else if (answeredBy === "Grok") return xAiLogo;

        else return aiIcon;
    };

    const getImgStyles = (answeredBy: string) => {
        if (answeredBy.includes("GPT")) return "invert-0 dark:invert p-1 shadow-black dark:shadow-white";
        else if (answeredBy.includes("Grok")) return "invert-0 dark:invert shadow-black dark:shadow-white";

        return "bg-white dark:bg-black shadow-black";
    }

    // If only one model, show single avatar
    if (answeredByArray.length === 1) {
        const answeredBy = answeredByArray[0];
        const modelIcon = getModelIcon(answeredBy);
        const imgStyles = getImgStyles(answeredBy);

        return (
            <div
                data-tooltip-id="main-tooltip"
                data-tooltip-content={answeredBy}
                data-tooltip-place="top"
            >
                <img
                    src={modelIcon}
                    alt="AI Avatar"
                    className={`w-7 h-7 rounded-full shadow shadow-black object-cover object-center ${imgStyles}`}
                />
            </div>
        );
    }

    // If multiple models, show array of avatars
    return (
        <div
            data-tooltip-id="main-tooltip"
            data-tooltip-content={answeredByArray.join(", ")}
            data-tooltip-place="top"
            className="flex -space-x-1"
        >
            {answeredByArray.map((answeredBy, index) => {
                const modelIcon = getModelIcon(answeredBy);
                const imgStyles = getImgStyles(answeredBy);

                return (
                    <img
                        key={`${answeredBy}-${index}`}
                        src={modelIcon}
                        alt={`AI Avatar - ${answeredBy}`}
                        className={`w-6 h-6 rounded-full shadow shadow-black object-cover object-center border border-neutral-200 dark:border-neutral-700 ${imgStyles}`}
                    />
                );
            })}
        </div>
    );
}

export default AiAvatar;
